import { ExportState } from "./types";
import { ExportFilters } from "@/models/export/filters";

export const getExportFilters = (state: ExportState): ExportFilters => {
  return state.exportFilters;
};

